import styled from "styled-components";
import {LogoImageDefaultBox} from "./logo-image.default.box";

export const LogoImageSiBox = styled(LogoImageDefaultBox)`
    height: 3rem;
    
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        height: 3.4rem;
    }
`;
